import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import {
    lightBlue,
    amber,
    orange,
    green,
    grey,
    lightGreen,
    red
} from '@material-ui/core/colors';
import {
    Schedule,
    Timelapse,
    FindInPage,
    CheckCircle,
    RemoveCircle,
    Cancel,
    MonetizationOn,
    Warning,
    Storage,
    Autorenew
} from '@material-ui/icons';
import { SketchOrderStatus } from '../../lib/sketchOrderStatuses';

const style = {
    pendingChipStyle: {
        backgroundColor: lightBlue[500],
        color: '#FFFFFF',
    },
    inProgressChipStyle: {
        backgroundColor: amber[500],
        color: '#FFFFFF',
    },
    pendingReviewChipStyle: {
        backgroundColor: lightGreen[500],
        color: '#FFFFFF',
    },
    pendingRejectionChipStyle: {
        backgroundColor: orange[500],
        color: '#FFFFFF',
    },
    completeChipStyle: {
        backgroundColor: green[600],
        color: '#FFFFFF',
    },
    inactiveChipStyle: {
        backgroundColor: grey[500],
        color: '#FFFFFF',
    },
    errorChipStyle: {
        backgroundColor: red[500],
        color: '#FFFFFF'
    },
    inReviewChipStyle: {
        backgroundColor: lightBlue[500],
        color: '#FFFFFF',
    },
};

const renderStatusChip = (status, onDelete) => {
    switch (status) {
        case SketchOrderStatus.Pending:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.pendingChipStyle}
                        >
                            <Schedule color="inherit" />
                        </Avatar>
                    }
                    style={style.pendingChipStyle}
                    label="Pending"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.RevisionRequested:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.pendingChipStyle}
                        >
                            <Autorenew color="inherit" />
                        </Avatar>
                    }
                    style={style.pendingChipStyle}
                    label="Revision"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.Queued:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.pendingChipStyle}
                        >
                            <Storage color="inherit" />
                        </Avatar>
                    }
                    style={style.pendingChipStyle}
                    label="Queued"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.InProgress:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.inProgressChipStyle}
                        >
                            <Timelapse color="inherit" />
                        </Avatar>
                    }
                    style={style.inProgressChipStyle}
                    label="In Progress"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.PendingReview:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.pendingReviewChipStyle}
                        >
                            <FindInPage color="inherit" />
                        </Avatar>
                    }
                    style={style.pendingReviewChipStyle}
                    label="Pending Review"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.PendingRejection:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.pendingRejectionChipStyle}
                        >
                            <Cancel color="inherit" />
                        </Avatar>
                    }
                    style={style.pendingRejectionChipStyle}
                    label="Pending Rejection"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.Complete:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.completeChipStyle}
                        >
                            <CheckCircle color="inherit" />
                        </Avatar>
                    }
                    style={style.completeChipStyle}
                    label="Complete"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.Billed:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.completeChipStyle}
                        >
                            <MonetizationOn color="inherit" />
                        </Avatar>
                    }
                    style={style.completeChipStyle}
                    label="Billed"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.Incomplete:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.inactiveChipStyle}
                        >
                            <RemoveCircle color="inherit" />
                        </Avatar>
                    }
                    style={style.inactiveChipStyle}
                    label="Incomplete"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.Cancelled:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.inactiveChipStyle}
                        >
                            <Cancel color="inherit" />
                        </Avatar>
                    }
                    style={style.inactiveChipStyle}
                    label="Cancelled"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.Exception:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.errorChipStyle}
                        >
                            <Warning color="inherit" />
                        </Avatar>
                    }
                    style={style.errorChipStyle}
                    label="Needs Attention"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.BillingFailed:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.errorChipStyle}
                        >
                            <Warning color="inherit" />
                        </Avatar>
                    }
                    style={style.errorChipStyle}
                    label="Billing Failed"
                    onDelete={onDelete}
                />
            );
        case SketchOrderStatus.InReview:
            return (
                <Chip
                    avatar={
                        <Avatar
                            style={style.inReviewChipStyle}
                        >
                            <Timelapse color="inherit" />
                        </Avatar>
                    }
                    style={style.inReviewChipStyle}
                    label="In Review"
                    onDelete={onDelete}
                />
            );
        default:
            return (
                <Chip
                    label={status}
                    onDelete={onDelete}
                />
            );
    }
};

const SketchOrderStatusChip = props => renderStatusChip(props.status, props.onDelete);

SketchOrderStatusChip.propTypes = {
    status: PropTypes.string,
    onDelete: PropTypes.func,
};

SketchOrderStatusChip.defaultProps = {
    status: '',
};

export default SketchOrderStatusChip;
